import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'datatables.net-bs4/js/dataTables.bootstrap4.min.js';
import useAuth from '../../component/useAuth';
import Template from '../../component/Template';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import '../../Assets/css/vendors/datatables.css';
import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
//12/3/2024
import '../../Assets/css/kebabMenu.css';


export default function Users() {



    // Initialize users state as null
    const [userlist, setUserListData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [totalusers, setTotalUsers] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);

    const [retryAttempt, setRetryAttempt] = useState(0);
    const tableRef = useRef(null);
    const [istost, settost] = useState(false);
    function formatDate(dateString) {
        // Create a Date object from the provided dateString
        const date = new Date(dateString);

        // Extract individual date and time components
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
        const day = String(date.getDate()).padStart(2, '0');
        const hour = String(date.getHours()).padStart(2, '0');
        const minute = String(date.getMinutes()).padStart(2, '0');

        // Concatenate date and time components in the desired format
        return `${day}/${month}/${year}, ${hour}:${minute}`;
    }

    const isAuth = useAuth()
    const navigate = useNavigate();
    if (isAuth === false) {
        navigate("/admin/")
    }

    const encodeID = id => {
        return btoa(id);
    };

    // Function to handle changes in the search input field
    const handleSearchInputChange = (event) => {
        //console.log(event.target.value+"onchange");
        setSearchQuery(event.target.value);
    };


    useEffect(() => {
        // this message is used for tost

        settost(sessionStorage.getItem("message"));
        const fetchData = async () => {
            try {
                const { http } = Api();
                const today = new Date();
                const formattedDate = today.toISOString().split('T')[0]; // Format as YYYY-MM-DD
                console.log(formattedDate);

                const response = await http.get(`/getuserlist?page=${currentPage}`, {
                    params: {
                        limit: '50',
                    }
                });

                const userListData = response.data;

                console.log(response);


                setUserListData(userListData.data);
                setTotalUsers(response.data.total);
                setTotalPages(Math.ceil(response.data.total / 50));



            } catch (error) {

                // Retry logic with exponential backoff
                const delay = Math.pow(2, retryAttempt) * 1000; // Exponential backoff formula
                setTimeout(() => {
                    setRetryAttempt(retryAttempt + 1);
                }, delay);

                //window.location.reload();
                console.error('Error fetching faculty data:', error);
            }
        };

        fetchData();

    }, [retryAttempt, currentPage]);

    useEffect(() => {
        if (istost) {
            toast.success(istost);
            sessionStorage.removeItem("message");
            settost(false);
        }
    }, [istost]);


    //for kebabmenu 12/3/2024

    const [openKebabCourseId, setOpenKebabCourseId] = useState(null);

    // Function to toggle the kebab menu for a specific row
    const toggleKebabMenu = (userId) => {
        // Toggle the open state for the specified course ID
        setOpenKebabCourseId(prevCourseId => (prevCourseId === userId ? null : userId));
    };


    // Close kebab menu when clicking anywhere on the screen -- 20/3/2024
    useEffect(() => {
        function handleClickOutside(event) {
            // Check if any kebab menu is open
            const isOpen = openKebabCourseId !== null;

            // Check if click is outside kebab menu and any kebab menu is open
            if (isOpen && !event.target.closest('.kebab-menu')) {
                // Close the open kebab menu
                setOpenKebabCourseId(null);
            }
        }

        document.body.addEventListener('click', handleClickOutside);
        return () => {
            document.body.removeEventListener('click', handleClickOutside);
        };
    }, [openKebabCourseId]);



    useEffect(() => {
        const filteredAndSortedData = [...userlist].filter(userlists => {
            return (
                userlists.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
                userlists.name.toLowerCase().includes(searchQuery.toLowerCase())
            );
        })
        setfilteredAndSortedData(filteredAndSortedData);
    }, [searchQuery, userlist]);

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    return (
        <>
            <Template>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="py-3 d-flex justify-content-between align-items-center ">
                                        <h5>Users</h5>

                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="card-body pdg1">
                                        <div className="table-responsive ovrflw">
                                            <div className='row'>
                                                <div className='col-md-6 wdt' >
                                                    <p>
                                                        Showing {(currentPage - 1) * 50 + 1}{''}-
                                                        {Math.min((currentPage - 1) * 50 + 50, totalusers)} of {totalusers} entries
                                                    </p>
                                                </div>
                                                <div className='col-md-6 wdt' align='right'>
                                                    <input
                                                        type="text"
                                                        value={searchQuery}
                                                        onChange={handleSearchInputChange}
                                                        placeholder="Search..."
                                                        className='form-control'
                                                        style={{ width: '300px' }}
                                                    /></div></div>
                                            <table className="display dataTable table-striped table-bordered" ref={tableRef}>
                                                <thead>
                                                    <tr className="bg-primary">
                                                        <th>Sl No</th>
                                                        <th>Name</th>
                                                        <th>Email Id</th>
                                                        <th>Created At</th>
                                                        <th>Action</th> {/* New column for "View Log" link */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredAndSortedData.map((userlists, index) => {

                                                        const serialNumber = (currentPage - 1) * 50 + index + 1;

                                                        return (
                                                            <tr key={userlists.id}>
                                                                <td>{serialNumber}</td>
                                                                <td>{userlists.name}</td>
                                                                <td>{userlists.email}</td>
                                                                <td>{formatDate(userlists.created_at)}</td>
                                                                <td>
                                                                    <div className="kebab-menu">
                                                                        <button className="kebab-menu-button" onClick={() => toggleKebabMenu(userlists.id)}>
                                                                            &#8942;
                                                                        </button>
                                                                        {openKebabCourseId === userlists.id && (
                                                                            <div className="kebab-menu-items">
                                                                                <Link style={{ fontSize: '15px' }} to={`/admin/userslog/${encodeID(userlists.id)}`}>View Log</Link>
                                                                                <Link style={{ fontSize: '15px' }} to={`/admin/assignroles/${encodeID(userlists.id)}`}>Roles & Permissions</Link>

                                                                            </div>
                                                                        )}

                                                                    </div>
                                                                    {/*<Link to={`/userslog/${encodeID(userlists.id)}`}>
                                                                        <button className="btn btn-secondary" type="button" data-bs-toggle="modal" data-original-title="test" data-bs-target="#exampleModal">View Log</button></Link>*/}

                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                        {totalPages > 1 && (
                                                      <nav aria-label="..." style={{ cursor: "pointer" }}>
                                                      <ul className="pagination justify-content-center">
                                                          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                              <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                                                          </li>
                                                          <li className={`page-item`}>
                                                              <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                                                          </li>
                                                          {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                                                          {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                                                              <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                                                  <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                                                              </li>
                                                          ))}
                                                          {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
  
                                                          <li className={`page-item`}>
                                                              <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                                                          </li>
  
                                                          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                              <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                                                          </li>
                                                      </ul>
                                                  </nav>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Template>
        </>




    );
}
